export const formatTemplate = (str, data) => {
    data = data || {}
    Object.keys(data).forEach(key => {
        str = str.replace(new RegExp(`{${key}}`, 'g'), data[key])
    })
    return str
}